import React, { ReactElement, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { CheckboxGroupQuestion } from '~/widgets/survey/components/ui/CheckboxGroupQuestion';
import { HappyScale } from '~/widgets/survey/components/ui/HappyScale';
import { RadioGroupQuestion } from '~/widgets/survey/components/ui/RadioGroupQuestion';
import { OutlinedInputWithController } from '~components/reuseable/OutlinedInputWithController';
import { SurveyFormKeyEnum } from '~modules/surveys/forms/SurveyForm';
import { SurveyExtraQuestionModel } from '~modules/surveys/models/SurveyExtraQuestionModel';
import { SurveyQuestionModel } from '~modules/surveys/models/SurveyQuestionModel';
import { SurveyAnswerTypeIdEnum } from '~modules/surveys/types/SurveyAnswerTypeIdEnum';

interface IQuestionRendererProps {
  question: SurveyQuestionModel | SurveyExtraQuestionModel;
  name: string;
}

export const QuestionRenderer: React.FC<IQuestionRendererProps> = (props) => {
  const { question, name } = props;

  const { t } = useTranslation('survey');

  if (!question.answerTypeId) {
    return null;
  }

  const questionMap: Record<SurveyAnswerTypeIdEnum, ReactElement> = useMemo(
    () => ({
      [SurveyAnswerTypeIdEnum.RADIO_GROUP]: <RadioGroupQuestion name={name} answers={question.answers} />,
      [SurveyAnswerTypeIdEnum.CHECKBOX_GROUP]: <CheckboxGroupQuestion name={name} />,
      [SurveyAnswerTypeIdEnum.TEXT_LONG]: (
        <OutlinedInputWithController
          name={`${name}.${SurveyFormKeyEnum.textValue}`}
          fullWidth
          multiline
          rows={4}
          label={t('input.specify.label')}
          required
          hideErrorMessage
        />
      ),
      [SurveyAnswerTypeIdEnum.TEXT_SHORT]: (
        <OutlinedInputWithController
          name={`${name}.${SurveyFormKeyEnum.textValue}`}
          fullWidth
          label={t('input.specify.label')}
          required
          hideErrorMessage
        />
      ),
      [SurveyAnswerTypeIdEnum.HAPPY_INDEX_5]: (
        <HappyScale name={name} scaleType={SurveyAnswerTypeIdEnum.HAPPY_INDEX_5} />
      ),
      [SurveyAnswerTypeIdEnum.HAPPY_INDEX_10]: (
        <HappyScale name={name} scaleType={SurveyAnswerTypeIdEnum.HAPPY_INDEX_10} />
      ),
    }),
    [],
  );

  return questionMap[question.answerTypeId];
};
